import React, {useEffect, useMemo, useState} from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import moment from "moment";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import NavBreadcrumb from "../../components/NavBreadcrum";
import axiApi from "ApiCaller";
import navs from "./navs";
import useCustomTranslation from "core/customTranslation";
import ConditionalRender from "../../components/ConditionalRender";

const translations = {
    es: {
        dont: "La versión seleccionada no esta disponible.",
        version: "Versión"
    },
    en: {
        dont: "The selected version is not available.",
        version: "Version"
    }
}


const ReleaseDetail = () => {
    const {id} = useParams();
    const [items, setItems] = useState([]);
    const [title, setTitle] = useState("");
    const {t: _tR} = useTranslation("routes");
    const {t: _TC} = useCustomTranslation(translations);


    const {version} = useParams();

    const bread = useMemo(() => [
        {
            name: _tR("labels.releases"),
            url: "/releases/",
            current: false,
        },
        {
            name: _tR("labels.release"),
            url: `/releases/${id}/`,
            current: true,
        },
    ], [_tR]);


    useEffect(() => {
        axiApi
            .get(`/api/loggers/releases/${version}/`)
            .then((resp) => {
                if (resp.data.items.length === 0) {
                    setItems([]);
                    setTitle(_TC("dont"));
                    return;
                }
                setTitle(`${resp.data.version} - ${resp.data.title}`);
                setItems(resp.data.items);

            })
            .catch((e) => {
                console.error("Error fetching release details:", e);
            });
    }, [id]);

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread}/>
            <div className="mt-4">
                <h3 className="mb-4">{_TC("version")}: {title}</h3>
                <ConditionalRender condition={items.length > 0}>
                    <div className="col-12">
                        <ul className="m-0">
                            {
                                items.map((item) => (
                                    <li key={item.id} className="mb-4 list-unstyled">
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}>
                                            <h5 className="mb-1">
                                                <strong>{item.version}</strong>{" "}
                                                {item.name}
                                            </h5>
                                            <small className="text-muted">
                                                {moment(item.created_at).format(
                                                    "MMMM D, YYYY"
                                                )}
                                            </small>
                                        </div>
                                        <ul className="mt-2">
                                            {item.lines_release.map((line) => (
                                                    <li
                                                        key={line.id}
                                                        className="mb-2">
                                                        <strong>
                                                            {line.title}
                                                        </strong>
                                                        <p
                                                            style={{
                                                                whiteSpace:
                                                                    "pre-wrap",
                                                            }}>
                                                            {line.description}
                                                        </p>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </ConditionalRender>

            </div>
        </>
    );
};

export default ReleaseDetail;
